export const DashboardHeaderSchema = [
    {
        statsHeading:"Total Subscription",
        ProgressBarClassName:"ProgressBar",
        value: 0,
        totalSubscriptionPercentage: 100
    },
    {
        statsHeading:"Total Allotments",
        ProgressBarClassName:"AllotmentBar",
        value: 0,
        totalSubscriptionPercentage: 100

    },
    {
        statsHeading:"Total Rejections",
        ProgressBarClassName:"ProgressBar",
        value: 0,
        totalSubscriptionPercentage: 100
    },
    {
        statsHeading:"Total Modified",
        ProgressBarClassName:"AllotmentBar",
        value: 0,
        totalSubscriptionPercentage: 100
    },
    {
        statsHeading:"Total Cancellations",
        ProgressBarClassName:"ProgressBar",
        value: 0,
        totalSubscriptionPercentage: 100
    }
];